async function applyDiscount(e) {
  let value = e.previousElementSibling.value
  console.log(value)
     const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({ discount: value,sections: ["mini-cart"] }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const cartContent = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
       document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
}


class CustomCountdownDays extends HTMLElement {
  constructor() {
    super();
    this.days = this.getAttribute("data-days")*1 || 0
    this.first_time_node = this.getAttribute("data-first-node") || "0"
    this.end_time_node = this.getAttribute("data-end-node") || "0"
    this.now_time = this.getAttribute("data-now") || new Date()
  }
   connectedCallback() {
    this.updateCountdown();
  }
  updateCountdown(){
        let now = Date.parse(this.now_time)
        var first_end = false
        var end_time = false
        var time_end = false
        if (this.first_time_node && this.first_time_node !== "0") {
            first_end = this.parseDate(this.first_time_node);
        }
        
        if (this.end_time_node && this.end_time_node !== "0") {
          end_time = this.parseDate(this.end_time_node);
          if (end_time <= now) time_end = true;
        }
        
      let end = null
      if (time_end) {
        if (this.timer) clearInterval(this.timer);
          this.closest(".product-time-limit--countdown").style.display = "none"
          return; 
      }

      if (this.days > 0) {
        if (first_end  && first_end > now) {
            end = first_end
        }else if (first_end) {
            end = new Date(first_end);
            while (end <= now) {
              end.setDate(end.getDate() + this.days);
              if (end >= end_time) {
              end = end_time
                  break; 
              }
            }
        }
      }else{
        end = end_time
      }
        if (!end || isNaN(end.getTime())) {
          this.closest(".product-time-limit--countdown").style.display = "none"
          return;
        }
        console.log(end);
        
        let end_parse = Date.parse(end)
        console.log(end_parse);
        
        let time = end - now
        let x = setInterval(() => {
            time = time-1000
            let time_obj = this.get_compare_time(time)
            this.querySelector(".days").innerHTML = time_obj.DD
            this.querySelector(".hours").innerHTML = time_obj.HH
            this.querySelector(".minutes").innerHTML = time_obj.MM
            this.querySelector(".seconds").innerHTML = time_obj.SS
            if (time <= 0) {
                this.closest(".product-time-limit--countdown").style.display = "none"
                clearInterval(x);
                return
            }
        }, 1000)
        
  }
  parseDate(str) {
    if (!str || str === "0") return null;
    const parts = str.split("-").map(Number);
    const [y, m, d, h = 0, min = 0, s = 0] = parts;
    return new Date(y, m - 1, d, h, min, s);
  }
  get_compare_time(time) {
        let days = Math.floor(time / (1000 * 60 * 60 * 24));
        let hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((time % (1000 * 60)) / 1000);
        days = days >= 10 ? days : "0" + days
        hours = hours >= 10 ? hours : "0" + hours
        minutes = minutes >= 10 ? minutes : "0" + minutes
        seconds = seconds >= 10 ? seconds : "0" + seconds

      return {
          DD: days,
          HH: hours,
          MM: minutes,
          SS: seconds
      }
  }
 
}

customElements.define('custom-countdown-days', CustomCountdownDays);

// product bundle 
document.addEventListener("DOMContentLoaded", function () {

  // 1️⃣ Bundle（加购用）
  function getBundleData() {
    let totalPrice = 0;
    let totalCompare = 0;
    let selectedValues = [];
    let bundleHtml = "";
    let relatedSelectedValues = []

    $(".custom_gift_bundling:checked").each(function () {
      let variantId = $(this).val();
      let obj = { 'id':variantId, 'quantity':1 }
      let title = $(this).attr("data-title");
      let price = parseInt($(this).attr("data-price")) || 0;
      let compare = parseInt($(this).attr("data-comparer-price")) || 0;

      totalPrice += price;
      totalCompare += compare;
      selectedValues.push(obj);

      bundleHtml += `
        <div class="product-bundles-grid-item">
          <div>${title}</div>
          <div>x1</div>
        </div>
      `;
    });

    $(".related-product-checkbox:checked").each(function () {
      const wrapper = $(this).parents(".variant-related-product");
      const qtyInput = wrapper.find(".quantity-selector__input")[0];
      let quantity = parseInt(qtyInput?.value || 1);
      if (isNaN(quantity) || quantity < 1) { quantity = 1; }
      let variantId = $(this).val();
      let obj = { 'id':variantId, 'quantity':quantity }
      relatedSelectedValues.push(obj);
    });

    let currentValues = selectedValues.concat(relatedSelectedValues)
    //构建hidden input的逻辑可以根据需要放在这里
    $(".custom-product-bundle-faceplate").html(bundleHtml);

    return { totalPrice, totalCompare };
  }

  // 2️⃣ Free Gift（赠品逻辑）
  function getFreeGiftData() {
    let totalPrice = 0;
    let totalCompare = 0;
    let giftHtml = "";

    $(".related-product-checkbox:checked").each(function () {
      let $parent = $(this).closest(".variant-related-product");
      let quantity = parseInt($parent.find(".variant_quantity_input_product").val()) || 1;
      let title = $parent.attr("data-free-product");
      let price = parseInt($parent.attr("data-free-price")) || 0;
      let compare = parseInt($parent.attr("data-free-comparer-price")) || 0;

      totalPrice += (price * quantity);
      totalCompare += (compare * quantity);

      giftHtml += `
        <div class="product-bundles-grid-item free-gift">
          <div>${title}</div>
          <div class="custom-quantity-num">x${quantity}</div>
        </div>
      `;
    });

    $(".custom-product-freegift-faceplate").html(giftHtml);
    return { totalPrice, totalCompare };
  }

  $(document).ready(function() {
    $(document).on('change', '.related-product-checkbox', function() { getFreeGiftData(); });
    $(document).on('click', '.quantity-selector__button', function() {
      const $input = $(this).closest('quantity-selector').find('.variant_quantity_input_product');
      setTimeout(function() { $input.trigger('change'); }, 100); 
    });
    $(document).on('change', '.variant_quantity_input_product', function() { getFreeGiftData(); });
  });

  // 3️⃣ 总价计算（核心修复版）
  function updateTotalPrice() {
    const $el = $(".custom-product-TotalPrice");
    
    /* --- 新增：针对你提供的 HTML 定位变体标题 --- */
    // 我们定位第一个 selected-variant-title，因为它通常是显示名字的
    const $variantTitleEl = $(".selected-variant-title").first(); 

    // 实时抓取变体单选框
    let $activeVariant = $('.block-swatch__radio:checked'); 
    
    if ($activeVariant.length > 0) {
      let variantPrice = parseInt($activeVariant.attr("data-product-price")) || 0;
      let variantCompare = parseInt($activeVariant.attr("data-product-compare-price")) || 0;
      
      /* --- 新增：更新变体标题文字 --- */
      let variantTitle = $activeVariant.attr("data-product-title");
      if (variantTitle && $variantTitleEl.length > 0) {
        $variantTitleEl.text(variantTitle); // 这里会把 "Default Title" 换成选中的变体名
      }

      // 更新容器上的 data 属性
      $el.attr("data-base-price", variantPrice);
      $el.attr("data-base-compare-price", variantCompare);
    }

    let basePrice = parseInt($el.attr("data-base-price")) || 0;
    let baseCompare = parseInt($el.attr("data-base-compare-price")) || 0;

    let bundleData = getBundleData();
    let freeGiftData = getFreeGiftData();

    let totalPrice = basePrice + bundleData.totalPrice + freeGiftData.totalPrice;
    let totalCompare = baseCompare + bundleData.totalCompare + freeGiftData.totalCompare;

    let formattedPrice = "$" + (totalPrice / 100).toFixed(2);
    let formattedCompare = "$" + (totalCompare / 100).toFixed(2);

    /* --- 新增：价格去重（如果原价=现价，只显示一个） --- */
    let compareHtml = "";
    if (totalCompare > totalPrice) {
      compareHtml = `<span class="compare-price" style="text-decoration:line-through;color:#999;margin-left:6px;">${formattedCompare}</span>`;
    }

    $el.html(`
      <span class="current-price" style="font-weight:bold;">${formattedPrice}</span>
      ${compareHtml}
    `);
  }

  // 初始化
  updateTotalPrice();

  // 监听（关键）
  $(document).on("change", ".custom_gift_bundling, .related-product-checkbox", updateTotalPrice);
  $(document).on("change", ".variant_quantity_input_product", updateTotalPrice);
  
  /* --- 新增：关键变体切换监听 --- */
  $(document).on("change", ".block-swatch__radio", updateTotalPrice);

  $(document).on('click', '.quantity-selector__button', function() {
    const $input = $(this).closest('quantity-selector').find('.variant_quantity_input_product');
    setTimeout(function() { $input.trigger('change'); }, 100);
  });
});

function toggleShowed() {
  var bundlesText = document.querySelector(".product-discount-shower-bundling");
  var bundlesbtnstext = document.querySelector(".product-bundles-btns-text");
  var BundlesDown = document.querySelector(".BundlesDown-icon");

  if (bundlesText.classList.contains("expanded")) {
    bundlesText.classList.remove("expanded");
    bundlesbtnstext.textContent = "Show more";
    BundlesDown.classList.remove("up");
  } else {
    bundlesText.classList.add("expanded");
    bundlesbtnstext.textContent = "Show less";
    BundlesDown.classList.add("up");
  }
}

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".products-expand-bundling").forEach(container => {

    const wrapper = container.closest(".product-bundles-list-container");
    if (!wrapper) return;

    const footer = wrapper.querySelector(".bundles-footer");
    if (!footer) return;

    const button = footer.querySelector(".product-bundles-bespeak-item");
    const selectedCountEl = footer.querySelector(".selected-count");

    const items = container.querySelectorAll(".product-bundles__item");
    const checkboxes = container.querySelectorAll(".custom_gift_bundling");

    if (!button || !items.length) return;

    let collapsedHeight = 0;
    let isExpanded = false;

    const initialHiddenStates = Array.from(items).map(item => item.hasAttribute("hidden"));

    function calculateCollapsedHeight() {
      collapsedHeight = container.offsetHeight;
      if (!isExpanded) container.style.maxHeight = collapsedHeight + "px";
    }

    calculateCollapsedHeight();
    container.style.overflow = "hidden";

    function getHiddenCount() {
      return Array.from(items).filter(item => item.hasAttribute("hidden")).length;
    }

    button.textContent = `Show (${getHiddenCount()}) more`;

    button.addEventListener("click", function () {
      if (!isExpanded) {
        items.forEach(item => item.removeAttribute("hidden"));
        container.style.maxHeight = container.scrollHeight + "px";
        button.textContent = "Show less";
      } else {
        items.forEach((item, index) => {
          if (initialHiddenStates[index]) {
            item.setAttribute("hidden", "");
          } else {
            item.removeAttribute("hidden");
          }
        });
        container.style.maxHeight = collapsedHeight + "px";
        button.textContent = `Show (${getHiddenCount()}) more`;
      }
      isExpanded = !isExpanded;
    });

    window.addEventListener("resize", calculateCollapsedHeight);

    function updateSelectedCount() {
      const selected = Array.from(checkboxes).filter(cb => cb.checked).length;
      selectedCountEl.textContent = selected > 0 ? `${selected} Selected` : "";
    }

    checkboxes.forEach(cb => cb.addEventListener("change", updateSelectedCount));
  });

});



// product-form// bundle-save.js - 全局 theme.js 中可直接放
(function() {
  // 更新单个 block 的 bundle tip
  function updateBundleTip(scope) {
    const checkboxes = scope.querySelectorAll(".related-product-checkbox");
    const tipEl = scope.querySelector(".bundle-save-tip");
    if (!tipEl) return;

    let selectedCount = 0;
    let totalQuantity = 0;

    checkboxes.forEach(cb => {
      // 找到当前行对应的数量输入框
      const quantityInput = cb.closest(".variant-related-product")
        ?.querySelector(".quantity-selector__input");
      
      const qty = quantityInput ? parseInt(quantityInput.value) || 0 : 0;

      if (cb.checked) {
        selectedCount++;
        totalQuantity += qty;
      }
    });

    if (selectedCount === 0) {
      tipEl.style.display = "none";
      tipEl.textContent = "";
    } else if (totalQuantity === 2) {
      tipEl.style.display = "block";
      tipEl.textContent = `${totalQuantity} items Save 10%`;
    } else if (totalQuantity >= 3) {
      tipEl.style.display = "block";
      tipEl.textContent = `${totalQuantity} items Save 15%`;
    } else {
      tipEl.style.display = "block";
      tipEl.textContent = `${totalQuantity} item${totalQuantity > 1 ? 's' : ''} selected`;
    }
    
  }

  // 初始化所有 block
  document.querySelectorAll(".custom-variant-info-grid").forEach(scope => {
    updateBundleTip(scope);

    // 1. 监听 Checkbox 变化
    scope.addEventListener("change", e => {
      if (e.target.classList.contains("related-product-checkbox")) {
        updateBundleTip(scope);
      }
    });

    // 2. 监听输入框手动输入
    scope.addEventListener("input", e => {
      if (e.target.classList.contains("quantity-selector__input")) {
        updateBundleTip(scope);
      }
    });

    // 3. 核心：监听加减按钮的点击
    // 即使主题脚本拦截了事件，我们也可以通过监听 click 来延迟触发更新
    scope.addEventListener("click", e => {
      const btn = e.target.closest(".quantity-selector__button");
      if (btn) {
        // 使用 setTimeout(0) 是为了让主题自带的加减逻辑先执行（修改 input 里的值）
        // 然后我们的代码再读取修改后的值
        setTimeout(() => {
          updateBundleTip(scope);
        }, 0);
      }
    });
  });
})();

// product-video
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-product-videos').forEach(function(section){

    const productSwiperEl = section.querySelector('.custom-product-videos-swiper');
    const popup = document.querySelector('.popup-' + section.id.replace('product-video-',''));
    const popupSwiperEl = popup.querySelector('.popup_swiper_cards');

    const productSwiper = new Swiper(productSwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 12,
      freeMode: true,
      breakpoints: {
        0: {
          spaceBetween: 12
        },
        750: {
          spaceBetween: 14
        }
      }
    });

    const popupSwiper = new Swiper(popupSwiperEl, {
      effect: "cards",
      grabCursor: true,
      observer: true,
      observeParents: true
    });

    section.querySelectorAll('.custom-product-videos-unit').forEach(function(slide){
      slide.addEventListener('click', function(){
        const index = parseInt(slide.dataset.index);

        popup.style.display = "flex";

        popup.querySelectorAll('video').forEach(v=>v.pause());

        popupSwiper.update();
        popupSwiper.slideTo(index);

        const video = popupSwiper.slides[index].querySelector('video');
        if(video) video.play();
      });
    });

    popupSwiper.on('slideChange', function(){
      popupSwiper.slides.forEach((slide, i)=>{
        const video = slide.querySelector('video');
        if(video){
          if(i === popupSwiper.activeIndex){
            video.play();
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    });

    popup.querySelector('.close_icon').addEventListener('click', function(){
      popup.style.display = "none";
      popup.querySelectorAll('video').forEach(v=>v.pause());
    });

    section.querySelectorAll('.custom-product-videos-unit').forEach(slide=>{
      const video = slide.querySelector('video.my-custom-video-class');
      if(video){
        video.addEventListener('loadedmetadata', function(){
          slide.style.width = video.videoWidth + 'px';
        });
      }
    });
    popupSwiper.slides.forEach(slide=>{
      const video = slide.querySelector('video.popup-video-element');
      if(video){
        video.addEventListener('loadedmetadata', function(){
          slide.style.width = video.videoWidth + 'px';
        });
      }
    });

  });
});
